import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const IntegratedRewardsClientDashboardsTable = ({ 
    dashboards,
    setSelectedItem,
    setSelectedItemName,
    loading,
    editOnClick,
    previewOnClick,
    createOnClick,
    deleteOnClick 
}) => {
    const columns = [
            {
                minWidth: 30,
                maxWidth: 30,
                onRender: (item) => (
                    <ContextualMenu
                        editOnClick={editOnClick}
                        previewOnClick={previewOnClick}
                        id={item.integratedRewardsClientDashboardId}
                        item={item}
                        deleteOnClick={deleteOnClick}
                    />
                ),
            },
            {
                name: 'ID',
                fieldName: 'integratedRewardsClientDashboardId',
                minWidth: 40,
                maxWidth: 40,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'ClientId',
                fieldName: 'clientId',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'Client Name',
                fieldName: 'clientName',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'Published',
                fieldName: 'isPublished',
                minWidth:80,
                maxWidth:100,
                isResizable: true,
                onRender: (item) => item.isPublished ? 'Yes' : 'No',
            },
        ];
    
        const items = dashboards ?? [];
    
        const formatLabel = (item) => {
            if (!item) {
                return "";
            }
            if (item.clientName) {
                return item.clientName;
            }
            return String(item.integratedRewardsClientDashboardId ?? "");
        };

        const selectionHook = (items) => {
            const selected = items && items[0];
            setSelectedItem(selected && selected.integratedRewardsClientDashboardId);
            setSelectedItemName?.(formatLabel(selected));
        };
    
        return (
            <>
                <DetailsTable
                    items={items}
                    columns={columns}
                    selectionHook={selectionHook}
                    loading={loading}
                    mainColumn={'clientName'}
                    style={{
                        position: 'relative',
                        height: '80vh',
                        width: '80vw',
                    }}
                    CommandBar={
                        <CommandBarButton
                            iconProps={{ iconName: 'Edit' }}
                            text="Add Integrated Rewards Custom Dashboard"
                            onClick={() => createOnClick()}
                        />
                    }
                />
                <FeatureSummary
                    label="About Integrated Rewards Client Dashboards"
                    summary="This table displays all integrated rewards custom dashboards for clients, including client name and publish status. You can add, edit, or delete client dashboards. The Integrated Rewards feature allows clients to customize and manage dashboards that display third party rewards and incentives to users. Only clients with third party rewards enabled can access this feature. It appears as a section in the dashboard."
                />
            </>
        );
    };
    
    const moreIcon = { iconName: 'More' };
    
    const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
        const formatLabel = () => {
            if (!item) {
                return "";
            }
            if (item.clientName) {
                return item.clientName;
            }
            return String(item.integratedRewardsClientDashboardId ?? "");
        };

        const menuProps = {
            items: [
                {
                    key: 'print',
                    iconProps: { iconName: 'Edit' },
                    text: 'Edit',
                    onClick: () => editOnClick(id),
                },
                {
                    key: "Delete",
                    iconProps: { iconName: "Delete" },
                    text: "Delete",
                    onClick: () => deleteOnClick(id, formatLabel()),
                },
            ],
        };
    
        return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
    };

export default IntegratedRewardsClientDashboardsTable;
